import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Wedoflow',
    description:
        'Explore our 210+ premium and unique Webflow templates, from Portfolio, Agency, SaaS, Business, and other categories. High-performing & easy to customize.',
    url: 'https://www.wedoflow.com',
    ogImage: 'https://wedoflow.cdn.modulify.website/images/New-Banner.png'
}
